<template>
  <div v-if="isMobile">
    <div v-if="!showDetails">
      <app-payeh v-for="index in payeh.length" :key="index" :index="index - 1" :payeh="payeh[index - 1]"
        :showDetails="showDetails" @clicked="onClickPayehMobile">
      </app-payeh>
    </div>
    <div v-else>
      <app-detail :payeh="payeh[selectedPayeh]" :selectedVahed="selectedVahed" @clickedVahed="onClickVahed">
      </app-detail>
    </div>
  </div>
  <div v-else>
    <v-data-table :items="payeh" item-key="PayehID" :headers="payehHeaders" class="elevation-1 rounded no-first"
      :disable-pagination="true" :hide-default-footer="true" @click:row="onClickPayehWeb" v-model="selectedRows"
      :no-data-text="tableText" :item-class="rowClass">
      <template v-slot:[`item.Description`]="{ }">
        <a>نمایش دروس</a>
      </template>
      <template v-slot:[`item.Icon`]="{ item }">
        <font-awesome-icon :icon="item.Icon" />
      </template>
    </v-data-table>
    <div v-if="selectedPayeh != -1">
      <div class="halfPage">
        <div class="table-title">
          <b>دروس انتخاب شده</b>
        </div>
        <v-data-table :items="payeh[selectedPayeh].TitlePassed" :headers="passedHeaders" class="elevation-1 child"
          :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText"></v-data-table>
      </div>
      <div class="halfPage">
        <div class="table-title">
          <b>دروس کسری</b>
        </div>
        <v-data-table :items="payeh[selectedPayeh].TitleNotPassed" :headers="notPassedHeaders" class="elevation-1 child"
          :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText"></v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import Payeh from "./Payeh";
import Detail from "./Detail";

export default {
  components: {
    appPayeh: Payeh,
    appDetail: Detail,
  },
  data() {
    return {
      selectedPayeh: -1,
      selectedVahed: -1,

      payehHeaders: [
        {
          text: "",
          value: "PayehID",
          width: "0px",
          sortable: false,
        },
        {
          text: "",
          value: "Icon",
          width: "0px",
          sortable: false,
        },
        {
          text: "عنوان پایه",
          value: "PayehName",
          width: "20%",
        },
        {
          text: "وضعیت",
          value: "Status",
          width: "10%",
        },
        {
          text: "تاریخ شروع",
          value: "StartDate",
          width: "10%",
        },
        {
          text: "تاریخ پایان",
          value: "EndDate",
          width: "10%",
        },
        {
          text: "معدل",
          value: "Avrg",
          width: "10%",
        },
        {
          text: "آیین نامه",
          value: "NezamName",
          width: "28%",
        },
        {
          text: "",
          value: "Description",
          width: "12%",
          sortable: false,
        },
      ],
      passedHeaders: [
        {
          text: "کد درس",
          value: "TitleID",
          width: "8%",
        },
        {
          text: "عنوان",
          value: "TitleName",
          width: "18%",
        },
        {
          text: "وضعیت",
          value: "State",
          width: "16%",
        },
        {
          text: "نمره",
          value: "Score",
          width: "8%",
        },
      ],
      notPassedHeaders: [
        {
          text: "کد درس",
          value: "ID",
          width: "8%",
        },
        {
          text: "عنوان",
          value: "Name",
          width: "26%",
        },
        {
          text: "واحد",
          value: "Vahed",
          width: "8%",
        },
        {
          text: "ساعت",
          value: "Saat",
          width: "8%",
        },
      ],
      selectedRows: [],
    };
  },
  created() {
    if (this.$route.query.index) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getAllPayeh");
  },
  computed: {
    payeh() {
      return this.$store.getters.payehha;
    },
    showDetails() {
      return this.selectedPayeh > -1;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },

  methods: {
    /**
     * class for selected payeh in web mode
     */
    rowClass(item) {
      let rowClass = this.selectedRows.includes(item.PayehID) ? "selected" : "";
      return rowClass;
    },
    /**
     * user click on payeh in mobile mode
     */
    onClickPayehMobile(index) {

      this.$store.commit("SET_HEADER_TITLE", this.payeh[index].PayehName);


      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          index: index
        }
      });
    },
    /**
     * user click on payeh in web mode
     */
    onClickPayehWeb(row, details) {
      let keyID = row.PayehID;

      if (!this.selectedRows.includes(keyID)) {
        this.selectedRows = [keyID];
        this.selectedPayeh = details.index;
      }
    },
    /**
     * expand / collapse vahed in mobile mode
     */
    onClickVahed(index) {
      if (this.selectedVahed == index) {
        this.selectedVahed = -1;
      } else {
        this.selectedVahed = index;
      }
    },
  },
  watch: {

    '$route'(to, from) {
      this.selectedPayeh = this.$route.query.index ?? -1;

    }
  },
};
</script>
<style>
.halfPage {
  background-color: white;
}
</style>
